import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { httpOk, PATCH, POST } from 'helpers/api';
import { SET_ACCOUNT } from 'store/account/action';

import ConfirmModal from 'components/ConfirmModal';

import { ReactComponent as ProfileIcon } from 'assets/icons/header/profile.svg';
import { ReactComponent as PhoneIcon } from 'assets/icons/header/phone.svg';
import { ReactComponent as EmailIcon } from 'assets/icons/header/email.svg';
import { ReactComponent as SaveIcon } from 'assets/icons/save.svg';
import { ReactComponent as LockIcon } from 'assets/icons/lock.svg';
import { ReactComponent as LogoutIcon } from 'assets/icons/header/logout.svg';

function Settings() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const reduxAccount = useSelector(state => state.account)

	const [confirmModal, setConfirmModal] = useState(false)
	const [user, setUser] = useState({ ...reduxAccount })

	async function updateUser() {
		const response = await PATCH('/users/me/', user)
		if (httpOk(response)) {
			dispatch(SET_ACCOUNT({ ...reduxAccount, ...response.data }))
		}
	}

	async function updatePassword(change_token) {
		const response = await POST('/users/password/change/', { ...user, change_token })
		if (httpOk(response)) {

		}
	}

	async function checkPassword() {
		const response = await POST('/users/password/verify/', { current_password: user.current_password }, { notification: false })
		if (httpOk(response)) {
			updatePassword(response.data.change_token)
		}
	}

	function handleChange(e) {
		var userCopy = { ...user }
		userCopy[e.target.name] = e.target.value;
		setUser(userCopy)
	}

	async function logout() {
		const response = await POST('/users/logout/', {
			refresh: reduxAccount.refresh
		})
		if (httpOk(response)) {
			navigate('/auth/login')
		}
	}

	return (
		<>
			<div>
				<div className="main-content-title">
					{t('settings')}
				</div>

				<div className="main-content-subtitle">
					{t('personal_account_settings')}
				</div>
			</div>

			<div className="card">
				<div className="d-flex align-items-center gap-8 fz16 mb-32">
					<ProfileIcon />
					{t('account')}
				</div>

				<div className="text-fifth text-uppercase mb-16">
					{t('profile')}
				</div>

				<div className="grid2 gap-16 gapy-16 w-100 mb-16">
					<div className="form-group">
						<label htmlFor="name">{t('full_name')}</label>
						<input type="text" name="fio"
							value={user.fio} onChange={(e) => handleChange(e)} />
					</div>
					<div className="form-group">
						<label htmlFor="role">{t('role')}</label>
						<input type="text" name="role" disabled
							value={t(user?.role?.toLowerCase())} onChange={(e) => handleChange(e)} />
					</div>
					<div className="form-group">
						<label htmlFor="email">{t('email')}</label>
						<div className="left-icon">
							<input type="text" name="email"
								value={user.email} onChange={(e) => handleChange(e)} />
							<EmailIcon className="icon" />
						</div>
					</div>
					<div className="form-group">
						<label htmlFor="phone_number">{t('phone')}</label>
						<div className="left-icon">
							<input type="text" name="phone_number"
								value={user.phone_number} onChange={(e) => handleChange(e)} />

							<PhoneIcon className="icon" />
						</div>
					</div>
				</div>

				{/* <div className="form-group w-100 mb-16">
					<label htmlFor="department">{t('department')}</label>
					<div className="left-icon">
						<input type="text" name="department"
							value={user.fio} onChange={(e) => handleChange(e)} />
						<DepartmentIcon className="icon" />
					</div>
				</div> */}

				<button className="dark" onClick={() => updateUser()}>
					<SaveIcon width={16} />
					{t('save_changes')}
				</button>

				<hr />

				<div className="d-flex align-items-center gap-8 fz16 mb-32 text-uppercase text-fifth">
					<LockIcon />
					{t('security')}
				</div>

				<div className="form-group w-100 mb-16">
					<label htmlFor="current_password">{t('current_password')}</label>
					<input type="password" name="current_password" autoComplete='new-password'
						value={user.current_password} onChange={(e) => handleChange(e)} />
				</div>
				<div className="form-group w-100 mb-16">
					<label htmlFor="new_password">{t('new_password')}</label>
					<input type="password" name="new_password"
						value={user.new_password} onChange={(e) => handleChange(e)} />
				</div>
				<div className="form-group w-100 mb-16">
					<label htmlFor="new_password_confirm">{t('repeat_new_password')}</label>
					<input type="password" name="new_password_confirm"
						value={user.new_password_confirm} onChange={(e) => handleChange(e)} />
				</div>

				<button className="dark" onClick={() => checkPassword()}>
					<SaveIcon width={16} />
					{t('update_password')}
				</button>

				<hr />

				<div className="text-second mb-12">
					{t('logout_session_desc')}
				</div>

				<button className="outline danger w-fit-content" onClick={() => setConfirmModal(true)}>
					<LogoutIcon />
					{t('logout_account')}
				</button>
			</div>

			<ConfirmModal modal={confirmModal} setModal={setConfirmModal} confirm={logout} />
		</>
	)
}

export default Settings;